module.exports = "/_next/static/images/7e325aaf1519c64abc34fa242f3497a4-highFive.svg.webp";